// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27gHu","badges":"styles_badges__2IuPK"};